import { COUNTRY_CODE_EN } from './asset/country-code';
import { errorMessageEN } from './asset/error-message';
import { Marketplace_EN } from './asset/marketplace';
import { INDUSTRY_CODE_EN } from './asset/industry-code';
import { BalanceAssetEN } from './asset/balance-asset';
import { FINANCIAL_METRICS_EN } from './asset/financial-metrics';
import { FUNDER_BREAD_CRUMB_EN } from './asset/funder-bread-crumb';
import { FUNDER_PROFILE_EN } from './asset/funder-profile';
import { COMMON_EN } from './asset/common';
import { LOGIN_EN } from './asset/login';

export default {
    ...FUNDER_BREAD_CRUMB_EN,
    ...COUNTRY_CODE_EN,
    ...errorMessageEN,
    ...Marketplace_EN,
    ...INDUSTRY_CODE_EN,
    ...BalanceAssetEN,
    ...FINANCIAL_METRICS_EN,
    ...FUNDER_PROFILE_EN,
    ...COMMON_EN,
    ...LOGIN_EN,
}
